import { observable, action } from "mobx";
import {checkAuth} from "../../../utils/security";
import { urlApi } from "../../../config/Constantes"
import { inject } from "mobx-react";

export default class AppStore {
    //general
    @observable width;
    @observable gridMode;
    @observable innerHeight;
    @observable titulo;
    mobileSize;

    //sidebar
    @observable submenuAberto;
    @observable sidebarFechado;
    @observable expandirGrupoSidebar;
    @observable selectedMenu;

    //Topbar e botão Voltar
    @observable topbarVisivel;
    @observable topbarVoltarVisivel;
    @observable topbarVoltarLink;
    @observable topbarVoltarParams;
    @observable topbarVoltarClick;

    @observable baseUrl;
    @observable contentBackgroundWhite;

    @observable currentPage;

    @observable apiVersion;

    constructor() {
        // this.submenusAbertos = [];
        this.selectedMenu = null;
        this.sidebarFechado = false;
        this.expandirGrupoSidebar = "";
        this.width = window.innerWidth;
        this.mobileSize = 995;
        this.innerHeight = window.innerHeight;
        this.gridMode = false;
        this.baseUrl = urlApi 
        //"http://api.teconsvonline.com.br/API";
        this.contentBackgroundWhite = false;
        this.currentPage = null;

        this.topbarVisivel = true;
        this.topbarVoltarVisivel = false;
        this.topbarVoltarLink = "/";
        this.topbarVoltarParams = {};

        this.nome = "";

        this.submenuAberto ="";

        this.apiVersion = "";

    }

    showTopbar(bool){
        this.topbarVisivel = bool;
    }
    
    showVoltarTopBar(bool, link="/", params = null, onClick = null){
        this.topbarVoltarVisivel = bool;
        this.topbarVoltarLink = link;
        this.topbarVoltarParams = params;
        this.topbarVoltarClick = onClick
    }

    isMobile() {
        return (this.width < this.mobileSize);
    }

    toggleSideBar() {
        this.sidebarFechado = !this.sidebarFechado;
    }

    setCurrentPage(page) {
        this.currentPage = page;
    }

    toggleSideBarGroup(group) {
        if(group === this.expandirGrupoSidebar)
            this.expandirGrupoSidebar = "none";
        else
            this.expandirGrupoSidebar = group;
    }

    setSelectedMenu(menu){
        this.selectedMenu = menu;
    }

    setTitulo(value) {
        this.titulo = value;
    }
    
    check() {
        var currentUrl = window.location.href;
        var redirect = "redirect=";
        var redirectUrl = null;

        if (currentUrl.includes(redirect)) {
            window.localStorage.setItem('redirect', 'true');
            //window.localStorage.setItem('redirectUrl', currentUrl.substring(currentUrl.indexOf("redirect=") + 10));
            window.localStorage.setItem('appRedirected', 'false');
        }
        else if (window.localStorage.getItem('appRedirected') === 'false') {
            window.localStorage.setItem('redirect', 'false');
            //window.localStorage.setItem('redirectUrl', null);
        }

        window.localStorage.setItem('appRedirected', 'true');

        if (checkAuth()) {
            return false;
        }

        return true;
    }

    @action authenticate() {
        return new Promise((resolve, reject) => {
            this.authenticating = true;
            setTimeout(() => {
                this.authenticated = !this.authenticated;
                this.authenticating = false;
                resolve(this.authenticated);
            }, 0);
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/principal/stores/AppStore.js